import noty from 'components/generic/noty'
import {
	reactive,
	assign,
	not,
	Span,
	Button,
	Div,
	P,
	Pre,
	A,
	LI,
	H2,
	H4,
	Variable,
	VBoolean,
	VString,
} from 'alkali'
import ConfirmationPopover from 'components/generic/ConfirmationPopover'
import Dropdown from 'components/generic/Dropdown'
//import AnalysisSectionEditor from 'components/analysis/AnalysisSectionEditor'
import { metaAnalysisInputs } from 'model/MetaAnalysis'
//import ChildWorkflowDialog from 'components/workflow/ChildWorkflowDialog'
//import WorkflowSelectionDialog from 'components/workflow/WorkflowSelectionDialog'
//import { WorkflowConfig, default as Workflow } from 'lib/workflow/Workflow'
import { default as UserWork, addReferencedWorkflow, workflowById } from 'model/UserWork'
import { get, post } from 'tools/request'
//import app from 'app/app'
import Renderer from '../../tools/Renderer'
import { downloadFile } from 'tools/DownloadFile'
import * as _ from 'lodash'
import {
	analysisType,
	selectedOutcomes,
	selectedOutcomeIds,
	selectedTreatments,
} from 'model/EvidenceSearch'
import { studyCollection, selectedStudies } from 'model/StudyCollection'
import { analysisResults } from 'model/Analysis'
import { structuredQuery } from 'model/SearchQuery'
import { track } from 'components/tracking/track'

//import * as markdownStyles from 'raw-loader!less-loader!./markdown.less' // need to get the contents to embed in HTML
import './markdown.less' // and load it as a stylesheet for this page
const TEMPLATE_HEADER = `\`\`\`{r knitinit, echo=FALSE}
knitr::opts_chunk$set(echo=FALSE, dev="png", fig.ext="png", dpi = $dpi)
knitr::opts_knit$set(rmarkdown.pandoc.to="$type")
\`\`\`
`

const htmlDocument = body =>
	`<html>
	<head><style>${markdownStyles}</style></head>
	<body class="analysis-results">
		<div class='result-content'>${body}</div>
	</body>
</html>`

const TABLE_OF_CONTENTS = `### **Table of Contents**
\`\`\`{r results='asis'}

	idx_start = 0
	cat(sapply(seq_along(o$workflows$Name), function(idx) {
		paste0(idx + idx_start, ". ", o$workflows$Name[[idx]], "\n")
		}), sep="")

\`\`\`
`

class AnalysisResults extends Span {
	fileName: string
	isLocked: boolean
	results: any
	inputs: any
	baseUrl: string
	rData: string
	parentHeader: string
	workflow: Workflow
	config: WorkflowConfig
	buttons: HTMLElement
	contentWell: HTMLElement
	apiCall: Promise<any>
	defaultTemplate: string
	template: any
	renderAsChild: boolean
	installedPackages: string[]
	snippets: { title: string; chunk?: string; handler?: any }[]
	markdownWithIds: {
		markdown: string
		id: string
	}[]
	rDataFile = 'data.R'
	get defaultPackage() {
		return 'DREmetafor'
	}
	get hasDefaultTemplate() {
		return true
	}
	headerTemplate = TEMPLATE_HEADER

	created(properties) {
		const v = reactive()
		properties.content = [
			Div('.row.analysis-results', [
				(this.contentWell = new Div('.result-content.well.col-md-10.col-md-offset-1', [
					Div([ 'Generating your report, please wait...' ])
				])),
			]),
		]
		this.buttons = new Div('.results-buttons')
	}
	attached() {
		this.contentWell.appendChild(this.parentNode.querySelector('.loader'))
	}

	setupSnippets() {
		// manually add "blank", which also happens to adjust index to match R
		this.snippets = [{ title: 'Snippet', chunk: '\n```{r}\n\n```\n' }].concat(
			this.canAddChildren
				? [
						{
							title: 'Table of Contents',
							chunk: TABLE_OF_CONTENTS,
						},
						{
							title: 'Child Workflow',
							handler: this.referenceWorkflow.bind(this),
						},
				  ]
				: []
		)
	}

	ready(properties) {
		let request
		if (properties.noRender) return
		if (properties.config.tab) return this.prepareData()
		const isUserTemplate = properties.config.isUserTemplate.valueOf()
		//this.prepareData()
		let whenSnippets
		if (isUserTemplate) {
			this.inputs.options.package = (this.inputs.Package || this.defaultPackage).replace(
				/DRE/,
				''
			)
			this.inputs.options.baseUrl = location.href.replace(/\/\w+$/, '/') // take of the last part of the URL to form the base url
			request = this.spinnerWhile(
				post('/portal/analysis/initializeData', {
					data: _.omit(this.inputs, 'Package'),
				})
			)
			whenSnippets = this.setupSnippets()
		} else {
			request = this.sendAnalysisRequest()
		}

		this.apiCall = request
			.then(results => {
				if (this.results) {
					const output = _.omit(results, 'session')
					this.results.set('Output', output)
					this.results.set('Inputs', this.inputs)
				}
				if (isUserTemplate) {
					this.buildUserTemplate(results)
					return whenSnippets
				} else{
					return this.buildDefaultTemplate(results)
				}
			})
			.catch(error => this.buildError(error.responseJSON || error))
	}
	prepareData() {
		this.inputs = exportData()
	}

	sendAnalysisRequest(): Promise<any> {
		throw new Error('Not implemented')
	}

	spinnerWhile(promise) {
		if (this.widget) {
			this.widget.startLoad()
			return promise.finally(() => this.widget.finishLoad())
		}
		return promise
	}

	buildDefaultTemplate(results) {
		this.baseUrl = results.externalMetaUrl + results.session
		//return this.fetchFullHTML(results).then(data => {
			//const html = this.formatOutput(data/*, true*/, tabs)
		const html = results.html
		$(this.contentWell).html(html)
		this.contentWell.prepend(this.buttons)
		this.addDownload(
			`/files/${this.fileName}.docx`,
			`${this.fileName}.docx`,
			'Download Microsoft Word',
			'fa-file-word-o',
			'Download Word',
			true
		)
		//this.addDownload(`/files/${this.rDataFile}`, this.rDataFile, 'Download R data', 'fa', 'R')
		//this.buildEditButton()
//		})
	}
	   
	buildEditButton() {
		if (!this.isLocked) {
			this.buttons.append(
				Button('.btn.btn-default.fa.fa-pencil', {
					title: 'Edit Template',
					onclick: this.startEditTemplate.bind(this),
				})
			)
		}
	}

	startEditTemplate() {
		const pckg = (this.inputs.options.package = (this.inputs.Package || 'metafor').replace(
			/DRE/,
			''
		))
		if (pckg != 'metafor') {
			return noty({
				text: `<h3>Building a template without metafor</h3>
							<p>The ${pckg.replace(
								/DRE/,
								''
							)} package was selected, but user template code can only be used with the metafor package.</p>`,
				layout: 'center',
				type: 'info',
				timeout: 300000,
			})
		}
		this.initUserTemplate()
	}

	initUserTemplate() {
		let isUserTemplate = this.config.isUserTemplate
		Promise.all([
			this.fetchRHeader(),
			'## New Analysis',
			/*post('/portal/analysis/getSnippet', {
				data: {
					snippet: 'cohort',
					params: this.inputs.data,
					options: this.inputs.options
				}
			}),*/
		]).then(([rHeader, snippet]) => {
			this.template.put({
				headerR: rHeader,
				sections: snippet.match(/[^#]*##([^\n]|\n[^#]|\n#[^#])+/g),
			})
			isUserTemplate.put(true)
		})
	}

	buildUserTemplate(results) {
		const isUserTemplate = this.config.isUserTemplate
		const analysis = this
		const viewOnly = reactive(false)
		let filesToDownload = reactive([])
		new Renderer({
			variable: this.template.sections,
			element: this,
			renderUpdate: () => {
				return this.fetchTemplatedAnalysis(results, !this.renderAsChild)
					.then(
						data => {
							const html = this.formatOutput(data.html)
							filesToDownload.put(data.files)
							if (this.buttons && this.buttons.parentNode == this.contentWell) {
								// need to remove it first, or the innerHTML setting will clear the event handlers
								this.contentWell.removeChild(this.buttons)
							}
							$(this.contentWell).html(html)
							this.replaceWorkflowSections(this.contentWell)
							assign(this.contentWell, {
								classes: {
									'hide-edit-buttons': viewOnly,
								},
							})
						},
						error => {
							$(this.contentWell).html(this.getRMarkdown(null, { sectionDividers: true }))
							this.contentWell.prepend(Pre([error.responseJSON || error.toString()]))
						}
					)
					.finally(() => {
						if (this.isLocked) return
						this.attachEditors()
						this.contentWell.prepend(this.buttons)
					})
			},
		})
		this.buttons.append(
			A('.download-button.btn.btn-default.fa.fa-book', {
				href: 'analysis.rmd',
				title: 'Download RMD Notebook',
				onclick: event => {
					event.preventDefault()
					downloadFile(
						'analysis.rmd',
						new Blob([this.getRMarkdown()], { type: 'text/rmarkdown' })
					)
				},
			}),
			A('.download-button.btn.btn-default.fa.fa-file-code-o', {
				href: 'analysis.rmd',
				title: 'Download HTML Page',
				onclick: event => {
					event.preventDefault()
					this.fetchTemplatedAnalysis(results, false, 'html').then(({ html }) => {
						const downloadContents = new Div()
						$(downloadContents).html(this.formatOutput(html))
						html = downloadContents.innerHTML
						html = '<html><body>' + html + '</body></html>'
						downloadFile('analysis.html', new Blob([html], { type: 'text/html' }))
					})
				},
			}),
			A('.download-button.btn.btn-default.fa.fa-file-word-o', {
				href: 'report.docx',
				download: 'report.docx',
				onclick(event) {
					if (this.downloadGenerated) {
						this.downloadGenerated = false
						return // already generated, just let it download
					}
					event.preventDefault()
					return analysis.fetchRenderFormatted().then(result => {
						this.downloadGenerated = true
						this.href = result
						window.navigatingToDownload = true
						this.click()
						window.navigatingToDownload = false
					})
				},
				title: 'Download Microsoft Word',
			}),
			A('.download-button.btn.btn-default.fa.fa-download', {
				href: 'file',
				download: 'file',
				display: filesToDownload.to(files => files.length > 0),
				onclick(event) {
					if (this.downloading) {
						this.downloading = false
						return // let it download
					}
					this.dropdown = new Dropdown({
						items: filesToDownload.map(file => ({
							content: file.name,
							onclick: () => {
								this.downloading = true
								this.download = file.name
								this.href = file.url
								if (file.name.match(/\.png|\.jpg|\.jpeg|\.gif/)) this.target = 'download'
								window.navigatingToDownload = true
								this.click()
								window.navigatingToDownload = false
							},
						})),
					})
					this.dropdown.show(event)
					event.preventDefault()
				},
				title: 'Download Additional Files',
			}),
			this.isLocked
				? null
				: Button('.btn.btn-default', {
						content: viewOnly.to(viewOnly => (viewOnly ? 'Show Editors' : 'Hide Editors')),
						onclick: () => viewOnly.put(!viewOnly.valueOf()),
				  }),
			this.config.workflows.length.valueOf() > 0
				? Button('.btn.btn-default.fa', {
						classes: {
							'fa-flash': not(this.config.deferChildRendering),
							'fa-expand': this.config.deferChildRendering,
						},
						title: this.config.deferChildRendering.to(deferChildRendering =>
							deferChildRendering
								? 'Render all the children workflows inline'
								: 'Defer rendering of child workflows for faster rendering'
						),
						onclick: () => {
							this.config.deferChildRendering.put(!this.config.deferChildRendering.valueOf())
						},
				  })
				: null,
			this.canAddChildren
				? Button('.btn.btn-default', {
						content: 'Child Workflows',
						onclick: () => {
							if (this.checkWorkflowExists()) {
								new ChildWorkflowDialog({
									referencedWorkflows: this.config.workflows,
									parentWorkflowId: this.workflow.valueOf().Id,
									workflowType: 'Child Workflow',
								}).show()
							}
						},
				  })
				: null,
			Button('.btn.btn-default.fa.fa-eraser', {
				display: this.hasDefaultTemplate && isUserTemplate.to(Boolean),
				title: 'Use Default Template',
				created() {
					new ConfirmationPopover(
						this,
						() => {
							isUserTemplate.put(false)
						},
						{
							placement: 'bottom',
							title: 'Delete template',
							text:
								'Do you want to delete your edited analysis template and use the default analysis template?',
						}
					)
				},
			})
		)
	}

	checkWorkflowExists() {
		if (!this.workflow.valueOf().Id) {
			noty({
				text: `<h3>Workflow must be saved</h3>
							<p>You must save the current workflow before you can add any child workflows to it.</p>`,
				layout: 'center',
				type: 'info',
				timeout: 300000,
			})
			return false
		}
		return true
	}

	fetchRenderFormatted() {
		return post('/portal/analysis/renderFormatted', {
			data: {
				analysisType: this.analysisType,
				rMarkdown: this.getRMarkdown(null, { forFormat: 'docx' }),
				format: 'docx',
			},
		})
	}

	fetchRHeader() {
		return this.spinnerWhile(
			post('/portal/analysis/getRHeader', {
				data: {
					analysisType: this.analysisType,
					params: this.inputs.data,
					options: this.inputs.options,
				},
			})
		)
	}
	fetchFullHTML(results) {
		this.baseUrl = results.externalMetaUrl + results.session
		const resultUrl = this.baseUrl + `/files/${this.fileName}.html`

		// Load the HTML generated by the analysis
		return $.get(resultUrl)
	}

	get hasParent() {
		return false
		//return this.workflow.parentId.valueOf()
	}
	get parentWorkflow() {
		return workflowById(this.workflow.parentId)
	}

	get canAddChildren() {
		return false
	}

	pandocContentType: string
	getRMDHeader(rData, asChild?: boolean) {
		return (
			(asChild
				? '```{r include=FALSE, echo=FALSE}'
				: this.headerTemplate
						.replace(/\$type/, this.pandocContentType)
						.replace(/\$dpi/, this.pandocContentType === 'docx' ? '400' : '72') +
				  '\n```{r setup, eval=!exists("is.cached"), include=FALSE, echo=FALSE}\n' +
				  'library("pander")\n') +
			this.getRHeader(rData, asChild) +
			'\n```\n'
		)
	}

	getRHeader(rData, asChild?: boolean) {
		if (rData) this.rData = rData
		else if (this.rData) rData = this.rData
		else rData = this.workflow.valueOf()?.results?.Output?.rData

		if (this.config.workflows.length.valueOf() > 0) {
			rData += '\np_parent <- p\nr_parent <- r\no_parent <- o\n'
		}
		let parentHeader = ''
		if (this.parentHeader) {
			parentHeader = this.parentHeader
		} else if (this.hasParent && !asChild) {
			let parentWorkflow = this.parentWorkflow
			if (parentWorkflow) {
				parentHeader =
					(parentWorkflow?.Data?.results?.Output.rData || '') +
					'\np_parent <- p\nr_parent <- r\no_parent <- o\n' +
					parentWorkflow.Data.template.headerR
			}
		}

		return (
			this.checkForBadSyntax(parentHeader) +
			'\n' +
			rData +
			'\n' +
			this.checkForBadSyntax(this.template.headerR)
		)
	}

	checkForBadSyntax(rCode) {
		return rCode.replace(/```/g, "```\nDo not use ''' in R code\n```")
	}

	referenceWorkflow(onSelect) {
		if (this.checkWorkflowExists()) {
			new WorkflowSelectionDialog({
				parentWorkflowId: this.workflow.valueOf().Id,
				referencedWorkflows: this.config.workflows,
				deferChildRendering: this.config.deferChildRendering,
				allowedTypes: ['Custom Report', 'Direct Meta Analysis', 'Cohort Analysis'],
				workflowType: 'Child Workflow',
				onSelect: selectedWorkflow => {
					if (!selectedWorkflow.Owner) {
						selectedWorkflow.Owner = { Id: this.workflow.Id.valueOf() }
						UserWork.defaultInstance.updateWorkflow(selectedWorkflow)
					}
					onSelect('workflow:' + selectedWorkflow.Id)
					this.rebuildWorkflowReferences()
				},
			}).show()
		}
	}

	rebuildWorkflowReferences() {
		const childWorkflows = []
		this.markdownWithIds.forEach(({ markdown, id }) => {
			const workflowReference = markdown.match(/^workflow:(\d+)/)
			if (workflowReference) {
				childWorkflows.push(+workflowReference[1])
			}
		})
		if (!_.isEqual(this.config.workflows.valueOf(), childWorkflows)) {
			const previousChildren = this.config.workflows.valueOf()
			this.config.workflows.put(childWorkflows)
			// if any children have been removed, unparent them
			_.difference(previousChildren, childWorkflows).forEach(workflowIdToRemove => {
				const workflowToUnparent = workflowById(workflowIdToRemove)
				workflowToUnparent.Owner = { Id: null }
				workflowToUnparent.Data.parentId = null
				UserWork.defaultInstance.updateWorkflow(workflowToUnparent)
			})
		}
	}

	getRMarkdown(
		rData?,
		options: { sectionDividers?: boolean; asChild?: boolean; forFormat?: string }
	) {
		const { sectionDividers, asChild, forFormat } = options || {}
		if (!this.template.sections) {
			return 'No custom template defined for this analysis'
		}
		this.markdownWithIds = this.template.sections.map(markdown => ({
			markdown,
			id: Math.random()
				.toString()
				.slice(2),
		}))

		const labels = {}
		let i = 1
		// Load the data.R generated by the analysis
		this.pandocContentType = forFormat || 'html'
		return (
			this.getRMDHeader(rData, asChild) +
			(forFormat
				? '\n<span></span>\n<style>\n' +
				  markdownStyles +
				  '\n</style>\n<div class="analysis-results">\n'
				: '') +
			this.markdownWithIds
				.map(({ markdown, id }) => {
					const workflowReference = markdown.match(/^workflow:(\d+)/)
					if (workflowReference) {
						try {
							const workflowAnalysis = this.loadAnalysisForWorkflow(+workflowReference[1])
							if (
								sectionDividers &&
								(this.config.deferChildRendering.valueOf() ||
									(this.workflow.deferChildrenRendering.valueOf() || []).includes(
										workflowAnalysis.workflow.Id
									))
							) {
								markdown =
									'<workflow-section>' + workflowAnalysis.workflow.Id + '</workflow-section>'
							} else {
								markdown = workflowAnalysis.analysisResults.getRMarkdown(null, {
									sectionDividers: false,
									asChild: true,
								})
							}
						} catch (error) {
							markdown = error.toString()
						}
					}
					return sectionDividers
						? `<div id="section-${id}" class="analysis-section"></div>\n\n${markdown}`
						: '\n\n' + markdown
				})
				.valueOf()
				.join('\n\n')
				.replace(/```\{r (\w+)(,|})/g, (text, label, suffix) => {
					// try to rename duplicate labels
					if (labels[label]) {
						labels[label] = true
						label = label + i++
						return '```{r ' + label + suffix
					}
					labels[label] = true
					return text
				}) +
			(forFormat ? '\n</div>' : '')
		).replace(/\r/g, '')
	}

	loadReferencedWorkflows() {
		const loadingWorkflows = []
		let referencedWorkflowIds = this.config.workflows.valueOf() || []
		if (this.hasParent) {
			referencedWorkflowIds = referencedWorkflowIds.concat([this.workflow.parentId.valueOf()])
		}
		for (const workflowId of referencedWorkflowIds) {
			if (!workflowById(workflowId)) {
				loadingWorkflows.push(
					get('/portal/Workflow/' + workflowId).then(workflow =>
						addReferencedWorkflow(workflow)
					)
				)
			}
		}
		return Promise.all(loadingWorkflows)
	}
	fetchTemplatedAnalysis({ rData, params, installedPackages }, sectionDividers, forFormat) {
		this.normalizedParams = params
		this.installedPackages = installedPackages
		return this.spinnerWhile(
			this.loadReferencedWorkflows().then(() =>
				post('/portal/analysis/render', {
					data: {
						analysisType: this.analysisType,
						rMarkdown: this.getRMarkdown(rData, { sectionDividers, forFormat }),
					},
				})
			)
		)
	}

	formatOutput(html, tabs, replaceImgs?: boolean) {
		let bodyStart = html.indexOf('<body>')
		if (bodyStart > -1) {
			// only the body
			html = html.slice(bodyStart + 6, html.indexOf('</body>'))
			/*html = html.replace(/<script>[\s\S]*?<\/script>/g, '')
			html = html.replace(/<style>[\s\S]*?<\/style>/g, '')*/
		}
		if (replaceImgs) html = html.replace(/src=/g, 'data-src=') // This is needed to prevent 404's of the images

		html = html.replace(/\<embed/g, '<img') // Replace embed with img for svg
		const html$ = $(html)

		html$.closest('table').addClass('table-primary table-striped')

		html$.find('a:not([href^="#"])').each((i, el) => {
			const $el = $(el)
			$el.attr('target', '_blank')
		})
		html$.find('img').each((i, img) => {
			if (img.alt && !/^plot of/.test(img.alt)) {
				img.parentNode.insertBefore(new P([img.alt]), img.nextSibling)
			}
		})
		html$.find('.section.level1').each((i, el) => {
			let $container = $(`<div class="containter"></div>`)
			let $list = $(`<ul class ="nav nav-tabs"> </ul>`)
			let $tabContent = $(`<div class="tab-content"></div>`)
			let $node

			$(el).children('div').each(function (index, node) {
				$(node).removeClass()
				$(node).addClass("tab-pane fade")
				$tabContent.append(node)
				let str = node.id
				str = str.replace(/-/g, ' ')

				$node = $(`<li class="nav-item"><a id="`+str+` "class="nav-link" data-toggle="tab" href=#`+str+` role=tabpanel>`+str+`</a><li>`)
				$list.append($node[0])
			})
			
			$list.find('.nav-link')[0].className += ' active'
			$tabContent.find('.tab-pane')[0].className += ' active show'
			el.append($list[0])
			el.append($tabContent[0])
		})
		html$.find('.section.level3.tabset.tabset-fade.tabset-dropdown').each((i, el) => {
			let $ddContainer = $(`<div class=dropdown show>
			<a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			`+$(el).children('h3').first().text()+`
		  </a>
			</div>`)
			$(el).children('h3').first().remove()
			let $ddMenu = $(`<div class="dropdown-menu" aria-labelledby="dropdownMenuLink"></div>`)
			$(el).children('div').each(function (index, node) {
				$(node).removeClass()
				$(node).addClass('studies')
				let $node = $(`<a class="dropdown-item" href="#`+node.id+`">`+node.id+`</a>`)
				$ddMenu.append($node)
			})
			$ddContainer.append($ddMenu)
			$(el).prepend($ddContainer[0])
			console.log(el)
		})
		html$.append(`
		<a href="#expe1" class="fa fa fa-times closer" >Link1</a>  	
		<div class="resume" id="expe1">Open Block 1</div>`)
		html$.append(`<script>
		jQuery(document).ready(function($) {
			$('.studies') .hide()
		  $('a[href^="#"]').on('click', function(event) {
			  var target = $(this).attr('href');
		  
			  $('.studies'+target).toggle();
		  
		  });
		  });
			</script>`)
		if (replaceImgs) this.replaceImgs(html$)
		return html$
	}

	loadAnalysisForWorkflow(workflowId: number, render?: boolean) {
		const workflow = workflowById(workflowId)
		const workflowData = workflow.Data
		return {
			workflow,
			get analysisResults() {
				if (!workflowData?.results?.Inputs) {
					throw new Error('Workflow ' + workflow.Name + ' has not been run/analyzed')
				}
				const analysisResultsComponent = analysisResultsModules[workflow.Type.Name]
				if (!analysisResultsComponent) {
					throw new Error(workflow.Type.Name + ' is not a valid workflow type to include')
				}
				return new analysisResultsComponent({
					noRender: !render,
					inputs: workflowData.results.Inputs,
					config: new WorkflowConfig(workflowData.config),
					template: reactive(workflowData.template),
					isLocked: true,
					renderAsChild: true,
					workflow: new Workflow(workflowData),
				})
			},
		}
	}

	replaceWorkflowSections(analysisNode, renderImmediately) {
		const whenRendered = []
		$('workflow-section', analysisNode).each((i, workflowSectionPlaceholder) => {
			const workflowId = workflowSectionPlaceholder.innerHTML
			const workflowAnalysis = this.loadAnalysisForWorkflow(workflowId, true)
			workflowSectionPlaceholder.parentNode.replaceChild(
				new Button('.btn.btn-default.render-workflow-btn', {
					content: 'Show contents of workflow: ' + workflowAnalysis.workflow.Name,
					onclick() {
						const sectionNode = this.parentNode.parentNode
						try {
							const { analysisResults } = workflowAnalysis
							sectionNode.parentNode.replaceChild(analysisResults, sectionNode)
							whenRendered.push(
								analysisResults.apiCall.then(() => {
									analysisResults.contentWell.className = ''
									analysisResults.contentWell.parentNode.className = ''
								})
							)
						} catch (error) {
							sectionNode.parentNode.replaceChild(new Span([error.toString()]), sectionNode)
						}
					},
				}),
				workflowSectionPlaceholder
			)
		})
		return Promise.all(whenRendered)
	}
	replaceImgs(html$) {
		// From https://css-tricks.com/test-support-svg-img/
		const supportsSVG = document.implementation.hasFeature(
			'http://www.w3.org/TR/SVG11/feature#Image',
			'1.1'
		)

		html$.find('img').each((i, img) => {
			const img$ = $(img)
			const src = this.baseUrl + '/files/' + img$.attr('data-src')
			const svgOrPng = /.*\.png\+svg$/.test(src)
			if (svgOrPng && supportsSVG) {
				img$.on('error', () => {
					img$.off('error').attr('src', src)
				})

				const newSrc = src.replace('png+svg', 'svg')
				img$.attr('src', newSrc)
			} else {
				img$.attr('src', src)
			}
		})
	}

	attachEditors() {
		const analysisType = this.analysisType

		const AddButton = Button('.btn.btn-default.add-new-section', {
			content: [Span('.fa.fa-plus-circle'), ' Add New Section'],
			onclick(e) {
				new Dropdown({
					items: analysis.snippets.map((snippet, snippetIndex) => {
						return {
							textContent: _.startCase(snippet.title),
							onclick: e => {
								let i = this.index
								if (isNaN(i)) {
									i = markdownWithIds.valueOf().length
								}
								if (snippet.handler) {
									return snippet.handler(newSection =>
										templateSections.splice(i, 0, newSection)
									)
								}
								let newTemplateSection = new VString(snippet.chunk)
								new AnalysisSectionEditor({
									headerR,
									template: newTemplateSection,
									analysis,
									onSave: () => {
										templateSections.splice(i, 0, newTemplateSection.valueOf())
									},
								}).show()
							},
						}
					}),
				}).show(e)
			},
		})
		const templateSections = this.template.sections
		const headerR = this.template.headerR
		const analysis = this
		const contentWell = this.contentWell

		const markdownWithIds = this.markdownWithIds
		const setupSection = ({ markdown, id }, i) => {
			const analysisSection = document.getElementById('section-' + id)
			if (!analysisSection) {
				return
			}
			const template = this.template.sections.property(i)
			let headerName = ''
			const nodes = []
			let nextNode = analysisSection.nextSibling
			while (nextNode && (!nextNode.tagName || nextNode.className != 'analysis-section')) {
				nodes.push(nextNode)
				nextNode = nextNode.nextSibling
			}
			let workflowId = template.valueOf().match(/^workflow:(\d+)/)
			workflowId = workflowId && +workflowId[1]
			const hasWorkflow = UserWork.workflowById(workflowId) // specifically don't use global workflowById so we don't load "referenced" workflows
			const editing = new VBoolean(false)
			let analysisSectionContent
			let editAnalysisSection
			let deferThisChildRendering = this.workflow.deferChildrenRendering.to(
				deferChildrenRendering => deferChildrenRendering.includes(workflowId)
			)
			analysisSection.append(
				(editAnalysisSection = new Div(
					'.edit-analysis-section',
					[
						Button(
							'.btn.btn-default.btn-sm.section-ordering',
							[Span('.fa.fa-fw.fa-arrow-up')],
							{
								title: 'Move up',
								display: i != 0,
								onclick: () => {
									templateSections.splice(
										i - 1,
										2,
										templateSections.get(i),
										templateSections.get(i - 1)
									)
									this.rebuildWorkflowReferences()
								},
							}
						),
						Button(
							'.btn.btn-default.btn-sm.section-ordering',
							[Span('.fa.fa-fw.fa-arrow-down')],
							{
								title: 'Move down',
								display: i != markdownWithIds.valueOf().length - 1,
								onclick: () => {
									templateSections.splice(
										i,
										2,
										templateSections.get(i + 1),
										templateSections.get(i)
									)
									this.rebuildWorkflowReferences()
								},
							}
						),
						Button(
							'.btn.btn-sm.btn-default',
							[
								Span(workflowId ? '.fa.fa-fw.fa-folder-open' : '.fa.fa-fw.fa-edit'),
								workflowId ? ' Open' : ' Edit',
							],
							{
								disabled: Boolean(workflowId && !hasWorkflow),
								title: workflowId
									? !hasWorkflow
										? 'You do not have access to open this workflow'
										: 'Open this workflow'
									: 'Edit this section of RMD',
								onclick: () => {
									if (workflowId) {
										const page = this.analysisPage
										page.gotoWorkflow(workflowId)
									} else {
										new AnalysisSectionEditor({
											headerR,
											template,
											analysis,
										}).show()
									}
								},
							}
						),
						workflowId && !this.config.deferChildRendering.valueOf()
							? Button('.btn.btn-default.fa', {
									classes: {
										'fa-flash': not(deferThisChildRendering),
										'fa-expand': deferThisChildRendering,
									},
									title: deferThisChildRendering.to(deferThisRendering =>
										deferThisRendering
											? 'Render child workflow inline'
											: 'Defer rendering of child workflow for faster rendering'
									),
									onclick: () => {
										if (deferThisChildRendering.valueOf()) {
											this.workflow.deferChildrenRendering.splice(
												this.workflow.deferChildrenRendering.indexOf(workflowId),
												1
											)
											$('.render-workflow-btn', analysisSection).click()
										} else this.workflow.deferChildrenRendering.push(workflowId)
									},
							  })
							: null,

						Button('.btn.btn-default.btn-sm.section-ordering', [Span('.fa.fa-fw.fa-close')], {
							title: 'Delete',
							created() {
								new ConfirmationPopover(
									this,
									() => {
										templateSections.splice(i, 1)
										analysis.rebuildWorkflowReferences()
										analysisSection.parentNode.removeChild(analysisSection)
									},
									{
										placement: 'right',
										container: document.body,
										title: workflowId ? 'Remove child workflow? ' : 'Delete section?',
									}
								)
							},
						}),
					],
					{
						onmouseover: () => {
							editing.put(true)
						},
						onmouseout: () => {
							editing.put(false)
						},
					}
				)),
				(analysisSectionContent = new Div('.analysis-section-content', {
					classes: {
						editing,
					},
				}))
			)
			analysisSectionContent.append(
				nodes,
				new AddButton({
					index: i + 1,
					container: analysisSection,
				})
			)
		}
		markdownWithIds.forEach(setupSection)
		this.contentWell.append(
			new AddButton({
				container: contentWell,
				display: markdownWithIds.to(sections => !sections.length),
			})
		)
	}

	addDownload(path, file, title, icon, content, defaultDownload: boolean) {
		return this.buttons.append(
			A('.download-button.btn.btn-default.fa.' + icon, {
				href: path ? this.baseUrl + path : '',
				download: file,
				content,
				title,
				onclick(event) {
					track({ event: 'download-meta-report' })
					if (defaultDownload) {
						return
					}
					event.preventDefault()
					get(this.href, {
						isJSON: false,
						data: {},
						noHeaders: true,
						xhrFields: {
							withCredentials: false,
						},
					}).then(dataR => downloadFile(file, new Blob([dataR], { type: 'text/r' })))
				},
			})
		)
	}

	buildError(error) {
		error = error.ResponseStatus ? error.ResponseStatus.Message : error
		console.error('Error encountered when posting.', error)
		this.contentWell.append([
			H2(['Error']),
			H4([
				`We\'re sorry - an error occurred while processing this Meta Analysis.
			Please try again in a few moments.	If the error persists, please report
			this error along with the settings you used (filters, groups, and outcome selections).`,
			]),
			Pre([error.toString()]),
		])
		const isUserTemplate = this.config.isUserTemplate
		const isTemplated = isUserTemplate.valueOf()
		this.contentWell.prepend(this.buttons)
		if (isTemplated && this.hasDefaultTemplate) {
			this.buttons.append(
				Button('.btn.btn-default.fa.fa-eraser', {
					title: 'Use Default Template',
					created() {
						new ConfirmationPopover(
							this,
							() => {
								isUserTemplate.put(false)
							},
							{
								placement: 'bottom',
								title: 'Delete template',
								text:
									'Do you want to delete your edited analysis template and use the default analysis template?',
							}
						)
					},
				})
			)
		} else {
			this.buildEditButton()
		}
	}
}
export function exportData() {
	let studies = studyCollection.valueOf().filter(study => selectedStudies.valueOf().includes(study.Id + ''))
	let data = studies.flatMap(study => study.outcomes.flatMap(outcome => outcome.cells.map(cell => {
		
	let isBinary = outcome.type == "Binary"
	let group = study.groups.find(group => group.Id == cell.group)
		return group && {
			UseAM: false,
			sd: isBinary ? undefined : cell.sd,
			ai: cell.number,
			days: outcome.time ? outcome.time.days : 365,
			category: outcome.category,
			definition: outcome.definition,
			fieldType: outcome.type,
			groupN: group.N,
			intervention: group.OriginalName,
			analyzeAs: group.analyzeAs,
			isPositive: outcome.isPositive,
			n1i: group.N,
			root: outcome.root,
			name: outcome.name,
			popName: outcome.popName,
			studyId: study.Id,
			time: outcome.time ? outcome.time.description : 'NA',
		}
	}).filter(cell => cell)))
	let pubData = studies.map(study => ({
				acronym: study.Acronym,
				country: study.Country,
				year: study.PublicationYear,
				source: study.Source,
				design: study.Designs.join(', '),
				study: study.FirstAuthor,
				studyId: study.Id,
				title: study.Title,
				trialNumbers: study.TrialOutcome,

	}))
	let inputs = {
		data: {
			data,
			pubData,
			interventions: 'interventions',
			transforms: [],
		},
		options: {
			isUserTemplate: true,
			isPositive: false,
			package: '',
			url: location.href,
			question: structuredQuery.valueOf().textQuery,
			searchTerm: selectedOutcomes.map(outcome => outcome.root),
			groups: selectedTreatments.map(treatment => treatment.name),
		},
		rawData: {
			data,
			interventions: 'interventions',
			references: [],
		},
		metaData: metaAnalysisInputs.data,
		metaOptions: metaAnalysisInputs.options,
		metaRawData: metaAnalysisInputs.rawData,
	}
	return inputs
}
export function doubleEncodeInputs({ data, options, rawData, Package }) {
	// For the time being, our JSON options are double-encoded, but
	// would love to eliminate this at some point.
	const encoded = {
		data: JSON.stringify(data),
		options: JSON.stringify(options),
		rawData: JSON.stringify(rawData),
	}
	if (Package) {
		encoded.Package = Package
	}
	return encoded
}

export default AnalysisResults

export let analysisResultsModules
